export enum AlertType {
  MODULE,
  ITEM,
}

export enum AlertLevel {
  // Can't be hidden
  _0_CRITICAL,
  // System issue
  _1_ERROR,
  // Rule conflict
  _2_RULE,
  // Side effect
  _3_UPDATED,
  // Action history
  _4_LOG,
  // Usually redundant
  _5_VERBOSE,
}
